import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      redirect: () => ({ name: 'RealTimeTracking' })
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: 'login' */ '@/views/login')
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import(/* webpackChunkName: 'home-base' */ '@/views/base'),
      children: [
        {
          path: '',
          redirect: () => ({ name: 'RealTimeTracking' })
        },
        {
          path: 'real-time-tracking',
          name: 'RealTimeTracking',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Real Time Tracking',
            permission: { page: 'Home',  name: 'RealTimeTracking', type: 'view' }
          },
          component: () => import(/* webpackChunkName: 'home' */ '@/views/home')
        },
        {
          path: 'kpi-tracking',
          name: 'KPITracking',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'KPI Tracking',
            permission: { page: 'Home',  name: 'KPITracking', type: 'view' }
          },
          component: () => import(/* webpackChunkName: 'home' */ '@/views/kpiTracking')
        }
      ]
    },
    {
      path: '/performance-cost-analysis',
      component: () => import(/* webpackChunkName: 'home-base' */ '@/views/base'),
      children: [
        {
          path: '',
          redirect: () => ({ name: 'CycleTimeUtilization' })
        },
        {
          path: 'cycle-time-utilization',
          name: 'CycleTimeUtilization',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Cycle Time Utilization',
            permission: { page: 'Performance Cost Analysis',  name: 'CycleTimeUtilization', type: 'view' }
          },
          component: () => import('@/views/performanceCostAnalysis/cycleTimeUtilization')
        },
        {
          path: 'on-time-performance-utilization',
          name: 'OnTimePerformanceUtilization',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'On-Time Performance Utilization',
            permission: { page: 'Performance Cost Analysis',  name: 'OnTimePerformanceUtilization', type: 'view' }
          },
          component: () => import('@/views/performanceCostAnalysis/onTimePerformanceUtilization')
        },
        {
          path: 'barge-cost-utilization',
          name: 'BargeCostUtilization',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Barge Cost Utilization',
            permission: { page: 'Performance Cost Analysis',  name: 'BargeCostUtilization', type: 'view' }
          },
          component: () => import('@/views/performanceCostAnalysis/bargeCostUtilization')
        },
        {
          path: 'cargo-capacity-utilization',
          name: 'CargoCapacityUtilization',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Cargo Capacity Utilization',
            permission: { page: 'Performance Cost Analysis',  name: 'CargoCapacityUtilization', type: 'view' }
          },
          component: () => import('@/views/performanceCostAnalysis/cargoCapacityUtilization')
        },
        {
          path: 'incident-and-safety-utilization',
          name: 'IncidentAndSafetyUtilization',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Incident and Safety Utilization',
            permission: { page: 'Performance Cost Analysis',  name: 'IncidentAndSafetyUtilization', type: 'view' }
          },
          component: () => import('@/views/performanceCostAnalysis/incidentSafetyUtilization')
        },
        {
          path: 'fuel-supply-management',
          name: 'FuelSupplyManagement',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Fuel Supply Management',
            permission: { page: 'Performance Cost Analysis',  name: 'FuelSupplyManagement', type: 'view' }
          },
          component: () => import('@/views/performanceCostAnalysis/fuelSupplyManagement')
        },
        {
          path: 'barge-measurement-performance',
          name: 'BargeMeasurementPerformance',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Barge Measurement Performance (QCTSE)',
            permission: { page: 'Performance Cost Analysis',  name: 'BargeMeasurementPerformance', type: 'view' }
          },
          component: () => import('@/views/performanceCostAnalysis/bargeMeasurementPerformance')
        },
        {
          path: 'cost-analysis',
          name: 'CostAnalysis',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Cost Analysis',
            permission: { page: 'Performance Cost Analysis',  name: 'CostAnalysis', type: 'view' }
          },
          component: () => import('@/views/performanceCostAnalysis/costAnalysis')
        }
      ]
    },
    {
      path: '/sales-plan',
      component: () => import(/* webpackChunkName: 'sales-plan-base' */ '@/views/base'),
      children: [
        {
          path: '',
          redirect: () => ({ name: 'SalesPlanCreate' })
        },
        {
          path: 'list',
          component: () => import(/* webpackChunkName: 'sales-plan' */ '@/views/salesPlan'),
          children: [
            {
              path: '',
              name: 'SalesPlanList',
              meta: {
                breadcrumb: null,
                parent: null,
                title: 'List Data Sales Plan',
                permission: { page: 'Sales Plan', name: 'SalesPlanList', type: 'view' }
              },
              component: () => import(/* webpackChunkName: 'sales-plan' */ '@/views/salesPlan/list')
            },
            {
              path: 'detail',
              component: () => import(/* webpackChunkName: 'sales-plan' */ '@/views/salesPlan'),
              children: [
                {
                  path: 'annual',
                  name: 'SalesPlanDetailAnnual',
                  meta: {
                    breadcrumb: 'Detail Annual Sales Plan',
                    parent: { title: 'List Data Sales Plan', name: 'SalesPlanList' },
                    title: 'Detail Annual Sales Plan',
                    permission: { page: 'Sales Plan', name: 'SalesPlanDetailAnnual', type: 'view' }
                  },
                  component: () => import(/* webpackChunkName: 'sales-plan' */ '@/views/salesPlan/detail')
                },
                {
                  path: 'monthly',
                  name: 'SalesPlanDetailMonthly',
                  meta: {
                    breadcrumb: 'Detail Monthly Sales Plan',
                    parent: { title: 'List Data Sales Plan', name: 'SalesPlanList' },
                    title: 'Detail Monthly Sales Plan',
                    permission: { page: 'Sales Plan', name: 'SalesPlanDetailMonthly', type: 'view' }
                  },
                  component: () => import(/* webpackChunkName: 'sales-plan' */ '@/views/salesPlan/detail')
                }
              ]
            }
          ]
        },
        {
          path: 'create',
          name: 'SalesPlanCreate',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Upload Sales Plan',
            permission: { page: 'Sales Plan', name: 'SalesPlanCreate', type: 'add' }
          },
          component: () => import(/* webpackChunkName: 'sales-plan' */ '@/views/salesPlan/create')
        }
      ]
    },
    {
      path: '/barge-line-up',
      component: () => import(/* webpackChunkName: 'barge-line-up-base' */ '@/views/base'),
      children: [
        {
          path: '',
          redirect: () => ({ name: 'BargeLineUpList' })
        },
        {
          path: 'list',
          component: () => import(/* webpackChunkName: 'barge-line-up' */ '@/views/bargeLineUp'),
          children: [
            {
              path: '',
              name: 'BargeLineUpList',
              meta: {
                breadcrumb: null,
                parent: null,
                title: 'List Data Barge Line Up',
                permission: { page: 'Barge Line Up', name: 'BargeLineUpList', type: 'view' }
              },
              component: () => import(/* webpackChunkName: 'barge-line-up' */ '@/views/bargeLineUp/list')
            },
            {
              path: 'create',
              name: 'BargeLineUpAdd',
              meta: {
                breadcrumb: 'Add Barge Line Up',
                parent: { title: 'List Data Barge Line Up', name: 'BargeLineUpList' },
                title: 'Add Barge Line Up',
                permission: { page: 'Barge Line Up', name: 'BargeLineUpList', type: 'add' }
              },
              component: () => import(/* webpackChunkName: 'barge-line-up' */ '@/views/bargeLineUp/createDetailEdit')
            },
            {
              path: 'detail',
              name: 'BargeLineUpDetail',
              meta: {
                breadcrumb: 'Detail Barge Line Up',
                parent: { title: 'List Data Barge Line Up', name: 'BargeLineUpList' },
                title: 'Detail Barge Line Up',
                permission: { page: 'Barge Line Up', name: 'BargeLineUpList', type: 'view' }
              },
              component: () => import(/* webpackChunkName: 'barge-line-up' */ '@/views/bargeLineUp/createDetailEdit')
            },
            {
              path: 'edit',
              name: 'BargeLineUpEdit',
              meta: {
                breadcrumb: 'Edit Barge Line Up',
                parent: { title: 'List Data Barge Line Up', name: 'BargeLineUpList' },
                title: 'Edit Barge Line Up',
                permission: { page: 'Barge Line Up', name: 'BargeLineUpList', type: 'edit' }
              },
              component: () => import(/* webpackChunkName: 'barge-line-up' */ '@/views/bargeLineUp/createDetailEdit')
            },
            {
              path: 'upload',
              name: 'BargeLineUpUpload',
              meta: {
                breadcrumb: 'Upload Barge Line Up',
                parent: { title: 'List Data Barge Line Up', name: 'BargeLineUpList' },
                title: 'Upload Barge Line Up',
                permission: { page: 'Barge Line Up', name: 'BargeLineUpList', type: 'add' }
              },
              component: () => import(/* webpackChunkName: 'barge-line-up' */ '@/views/bargeLineUp/uploadForm')
            },
            {
              path: 'upload-result',
              name: 'BargeLineUpUploadResult',
              meta: {
                breadcrumb: null,
                parent: null,
                title: 'Upload Result',
                permission: { page: 'Barge Line Up', name: 'BargeLineUpList', type: 'add' }
              },
              component: () => import(/* webpackChunkName: 'barge-line-up' */ '@/views/bargeLineUp/uploadForm/UploadResult.vue')
            }
          ]
        }
      ]
    },
    {
      path: '/vessel-line-up',
      component: () => import(/* webpackChunkName: 'vessel-line-up-base' */ '@/views/base'),
      children: [
        {
          path: '',
          redirect: () => ({ name: 'VesselLineUpList' })
        },
        {
          path: 'list',
          component: () => import(/* webpackChunkName: 'vessel-line-up' */ '@/views/vesselLineUp'),
          children: [
            {
              path: '',
              name: 'VesselLineUpList',
              meta: {
                breadcrumb: null,
                parent: null,
                title: 'List Vessel Line Up',
                permission: { page: 'Vessel Line Up', name: 'VesselLineUpList', type: 'view' }
              },
              component: () => import(/* webpackChunkName: 'vessel-line-up' */ '@/views/vesselLineUp/list')
            },
            {
              path: 'create',
              name: 'VesselLineUpCreate',
              meta: {
                breadcrumb: 'Add Vessel Line Up',
                parent: { title: 'List Vessel Line Up', name: 'VesselLineUpList' },
                title: 'Add Vessel Line Up',
                permission: { page: 'Vessel Line Up', name: 'VesselLineUpList', type: 'add' }
              },
              component: () => import(/* webpackChunkName: 'vessel-line-up' */ '@/views/vesselLineUp/createDetailEdit')
            },
            {
              path: 'detail',
              name: 'VesselLineUpDetail',
              meta: {
                breadcrumb: 'Detail Vessel Line Up',
                parent: { title: 'List Vessel Line Up', name: 'VesselLineUpList' },
                title: 'Detail Vessel Line Up',
                permission: { page: 'Vessel Line Up', name: 'VesselLineUpList', type: 'view' }
              },
              component: () => import(/* webpackChunkName: 'vessel-line-up' */ '@/views/vesselLineUp/createDetailEdit')
            },
            {
              path: 'edit',
              name: 'VesselLineUpEdit',
              meta: {
                breadcrumb: 'Edit Vessel Line Up',
                parent: { title: 'List Vessel Line Up', name: 'VesselLineUpList' },
                title: 'Edit Vessel Line Up',
                permission: { page: 'Vessel Line Up', name: 'VesselLineUpList', type: 'edit' }
              },
              component: () => import(/* webpackChunkName: 'vessel-line-up' */ '@/views/vesselLineUp/createDetailEdit')
            },
            {
              path: 'loading-plan',
              component: () => import(/* webpackChunkName: 'vessel-line-up' */ '@/views/vesselLineUp'),
              children: [
                {
                  path: 'create',
                  name: 'LoadingPlanCreate',
                  meta: {
                    breadcrumb: 'Upload Loading Plan',
                    parent: { title: 'List Vessel Line Up', name: 'VesselLineUpList' },
                    title: 'Upload Loading Plan',
                    permission: { page: 'Vessel Line Up', name: 'VesselLineUpList', type: 'add' }
                  },
                  component: () => import(/* webpackChunkName: 'vessel-line-up' */ '@/views/vesselLineUp/loadingPlan/create')
                },
                {
                  path: 'detail',
                  name: 'LoadingPlanDetail',
                  meta: {
                    breadcrumb: 'Detail Loading Plan',
                    parent: { title: 'List Vessel Line Up', name: 'VesselLineUpList' },
                    title: 'Detail Loading Plan',
                    permission: { page: 'Vessel Line Up', name: 'VesselLineUpList', type: 'view' }
                  },
                  component: () => import(/* webpackChunkName: 'vessel-line-up' */ '@/views/vesselLineUp/loadingPlan/detail')
                }
              ]
            },
            {
              path: 'tentative-barge-schedule',
              name: 'TentativeBargeSchedule',
              meta: {
                breadcrumb: 'Tentative Barge Schedule',
                parent: { title: 'List Vessel Line Up', name: 'VesselLineUpList' },
                title: 'Tentative Barge Schedule',
                permission: { page: 'Tentative Barge Schedule', name: 'Tentative Barge Schedule', type: 'add' }
              },
              component: () => import(/* webpackChunkName: 'vessel-line-up' */ '@/views/vesselLineUp/tentativeBargeSchedule')
            }
          ]
        }
      ]
    },
    {
      path: '/barge-intelligent-system',
      component: () => import(/* webpackChunkName: 'barge-intelligent-system-base' */ '@/views/base'),
      children: [
        {
          path: '',
          redirect: () => ({ name: 'FleetArrangement' })
        },
        {
          path: 'fleet-arrangement',
          name: 'FleetArrangement',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'List Fleet Arrangement',
            permission: { page: 'Barge Intelligent System', name: 'FleetArrangement', type: 'view' }
          },
          component: () => import(/* webpackChunkName: 'fleet-arrangement' */ '@/views/fleetArrangement')
        },
        {
          path: 'contract-management',
          component: () => import(/* webpackChunkName: 'contract-management-base' */ '@/views/contractManagement'),
          children: [
            {
              path: '',
              redirect: () => ({ name: 'ContractManagementList' })
            },
            {
              path: 'list',
              name: 'ContractManagementList',
              meta: {
                breadcrumb: null,
                parent: null,
                title: 'List Contract Management',
                permission: { page: 'Barge Intelligent System', name: 'ContractManagementList', type: 'view' }
              },
              component: () => import(/* webpackChunkName: 'contract-management-list' */ '@/views/contractManagement/list')
            },
            {
              path: 'create',
              component: () => import(/* webpackChunkName: 'contract-management-create' */ '@/views/contractManagement/createDetailEdit'),
              children: [
                {
                  path: '',
                  name: 'ContractManagementCreate',
                  meta: {
                    breadcrumb: 'Add Contract',
                    parent: { title: 'List Contract Management', name: 'ContractManagementList' },
                    title: 'Add Contract',
                    permission: { page: 'Barge Intelligent System', name: 'ContractManagementList', type: 'add' }
                  },
                  component: () => import(/* webpackChunkName: 'contract-management-create' */ '@/views/contractManagement/createDetailEdit/form')
                },
                {
                  path: 'barge-certificate',
                  name: 'ContractManagementCreateBargeCertificate',
                  meta: {
                    breadcrumb: 'Create Barge Certificate',
                    parent: { title: 'Create Contract', name: 'ContractManagementCreate' },
                    title: 'Create Barge Certificate',
                    permission: { page: 'Barge Intelligent System', name: 'ContractManagementList', type: 'add' }
                  },
                  component: () => import(/* webpackChunkName: 'contract-management-barge-create' */ '@/views/contractManagement/bargeCertificate')
                },
                {
                  path: 'tug-certificate',
                  name: 'ContractManagementCreateTugCertificate',
                  meta: {
                    breadcrumb: 'Create Tug Certificate',
                    parent: { title: 'Create Contract', name: 'ContractManagementCreate' },
                    title: 'Create Tug Certificate',
                    permission: { page: 'Barge Intelligent System', name: 'ContractManagementList', type: 'add' }
                  },
                  component: () => import(/* webpackChunkName: 'contract-management-tug-create' */ '@/views/contractManagement/tugCertificate')
                }
              ]
            },
            {
              path: 'detail/:id',
              component: () => import(/* webpackChunkName: 'contract-management-detail' */ '@/views/contractManagement/createDetailEdit'),
              children: [
                {
                  path: '',
                  name: 'ContractManagementDetail',
                  meta: {
                    breadcrumb: 'Detail Contract',
                    parent: { title: 'List Contract Management', name: 'ContractManagementList' },
                    title: 'Detail Contract',
                    permission: { page: 'Barge Intelligent System', name: 'ContractManagementList', type: 'view' }
                  },
                  component: () => import(/* webpackChunkName: 'contract-management-detail' */ '@/views/contractManagement/createDetailEdit/form')
                },
                {
                  path: 'barge-certificate',
                  name: 'ContractManagementDetailBargeCertificate',
                  meta: {
                    breadcrumb: 'Detail Barge Certificate',
                    parent: { title: 'Detail Contract', name: 'ContractManagementDetail' },
                    title: 'Detail Barge Certificate',
                    permission: { page: 'Barge Intelligent System', name: 'ContractManagementList', type: 'view' }
                  },
                  component: () => import(/* webpackChunkName: 'contract-management-barge-detail' */ '@/views/contractManagement/bargeCertificate')
                },
                {
                  path: 'tug-certificate',
                  name: 'ContractManagementDetailTugCertificate',
                  meta: {
                    breadcrumb: 'Detail Tug Certificate',
                    parent: { title: 'Detail Contract', name: 'ContractManagementDetail' },
                    title: 'Detail Tug Certificate',
                    permission: { page: 'Barge Intelligent System', name: 'ContractManagementList', type: 'view' }
                  },
                  component: () => import(/* webpackChunkName: 'contract-management-tug-detail' */ '@/views/contractManagement/tugCertificate')
                }
              ]
            },
            {
              path: 'edit/:id',
              component: () => import(/* webpackChunkName: 'contract-management-edit' */ '@/views/contractManagement/createDetailEdit'),
              children: [
                {
                  path: '',
                  name: 'ContractManagementEdit',
                  meta: {
                    breadcrumb: 'Edit Contract',
                    parent: { title: 'List Contract Management', name: 'ContractManagementList' },
                    title: 'Edit Contract',
                    permission: { page: 'Barge Intelligent System', name: 'ContractManagementList', type: 'edit' }
                  },
                  component: () => import(/* webpackChunkName: 'contract-management-detail' */ '@/views/contractManagement/createDetailEdit/form')
                },
                {
                  path: 'barge-certificate',
                  name: 'ContractManagementEditBargeCertificate',
                  meta: {
                    breadcrumb: 'Edit Barge Certificate',
                    parent: { title: 'Edit Contract', name: 'ContractManagementEdit' },
                    title: 'Edit Barge Certificate',
                    permission: { page: 'Barge Intelligent System', name: 'ContractManagementList', type: 'edit' }
                  },
                  component: () => import(/* webpackChunkName: 'contract-management-barge-edit' */ '@/views/contractManagement/bargeCertificate')
                },
                {
                  path: 'tug-certificate',
                  name: 'ContractManagementEditTugCertificate',
                  meta: {
                    breadcrumb: 'Edit Tug Certificate',
                    parent: { title: 'Edit Contract', name: 'ContractManagementEdit' },
                    title: 'Edit Tug Certificate',
                    permission: { page: 'Barge Intelligent System', name: 'ContractManagementList', type: 'edit' }
                  },
                  component: () => import(/* webpackChunkName: 'contract-management-tug-edit' */ '@/views/contractManagement/tugCertificate')
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: '/barge-performance',
      component: () => import(/* webpackChunkName: 'barge-performance-base' */ '@/views/base'),
      children: [
        {
          path: '',
          redirect: () => ({ name: 'BargePerformanceList' })
        },
        {
          path: 'list',
          component: () => import(/* webpackChunkName: 'barge-performance-list' */ '@/views/bargePerformance'),
          children: [
            {
              path: '',
              name: 'BargePerformanceList',
              meta: {
                breadcrumb: null,
                parent: null,
                title: 'List Barge Performance',
                permission: { page: 'Barge Performance', name: 'BargePerformanceList', type: 'view' }
              },
              component: () => import(/* webpackChunkName: 'barge-performance-list' */ '@/views/bargePerformance/list')
            },
            {
              path: 'detail',
              name: 'BargePerformanceDetail',
              meta: {
                breadcrumb: 'Detail Barge Performance',
                parent: { title: 'List Barge Performance', name: 'BargePerformanceList' },
                title: 'Detail Barge Performance',
                permission: { page: 'Barge Performance', name: 'BargePerformanceList', type: 'view' }
              },
              component: () => import(/* webpackChunkName: 'barge-performance-list-detail' */ '@/views/bargePerformance/detail')
            }
          ]
        }
      ]
    },
    {
      path: '/facility-checklist-performance',
      component: () => import(/* webpackChunkName: 'facility-checklist-performance-base' */ '@/views/base'),
      children: [
        {
          path: '',
          name: 'FacilityChecklistPerformance',
          component: () => import(/* webpackChunkName: 'facility-checklist-performance' */ '@/views/facilityChecklistPerformance')
        }
      ]
    },
    {
      path: '/plan',
      component: () => import(/* webpackChunkName: 'plan-base' */ '@/views/base'),
      children: [
        {
          path: '',
          redirect: () => ({ name: 'MasterDataStandardTimeAnalysis' })
        },
        {
          path: 'standard-time-analysis',
          name: 'MasterDataStandardTimeAnalysis',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Standard Time',
            permission: { page: 'Plan', name: 'MasterDataStandardTimeAnalysis', type: 'view' }
          },
          component: () => import('@/views/masterData/standardTimeAnalysis')
        },
        {
          path: 'docking-schedule',
          name: 'MasterDataDockingSchedule',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Docking Schedule',
            permission: { page: 'Plan', name: 'MasterDataDockingSchedule', type: 'view' }
          },
          component: () => import(/* webpackChunkName: 'plan-docking-schedule' */ '@/views/masterData/dockingSchedule')
        }
      ]
    },
    {
      path: '/fuel-management',
      component: () => import(/* webpackChunkName: 'fuel-management-base' */ '@/views/base'),
      children: [
        {
          path: '',
          redirect: () => ({ name: 'MasterDataFuelSupplyList' })
        },
        {
          path: 'fuel-supply-tugboat',
          name: 'MasterDataFuelSupplyList',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Fuel Consumption',
            permission: { page: 'Fuel Management', name: 'MasterDataFuelSupplyList', type: 'view' }
          },
          component: () => import('@/views/masterData/fuelSupply')
        },
        {
          path: 'fuel-supply',
          name: 'ReportFuelSupplyManagement',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Fuel Supply Management',
            permission: { page: 'Fuel Management', name: 'ReportFuelSupplyManagement', type: 'view' }
          },
          component: () => import(/* webpackChunkName: 'fuel-supply' */ '@/views/reports/fuelSupplyManagement')
        },
        {
          path: 'fuel-price',
          name: 'FuelPriceManagementList',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Fuel Price Management',
            permission: { page: 'Fuel Management', name: 'FuelPriceManagementList', type: 'view' }
          },
          component: () => import('@/views/masterData/fuelPrice')
        }
      ]
    },
    {
      path: '/reports',
      component: () => import(/* webpackChunkName: 'report-base' */ '@/views/base'),
      children: [
        {
          path: '',
          redirect: () => ({ name: 'DailyTripActivityReport' })
        },
        {
          path: 'daily-activity-report',
          component: () => import(/* webpackChunkName: 'daily-activity-report' */ '@/views/reports/dailyActivityReport'),
          children: [
            {
              path: '',
              redirect: () => ({ name: 'DailyTripActivityReport' })
            },
            {
              path: '',
              component: () => import(/* webpackChunkName: 'daily-activity-report' */ '@/views/reports/dailyActivityReport'),
              children: [
                {
                  path: 'list',
                  name: 'DailyTripActivityReport',
                  meta: {
                    breadcrumb: null,
                    parent: null,
                    title: 'Daily Trip Activity Report',
                    permission: { page: 'Reports', name: 'DailyTripActivityReport', type: 'view' }
                  },
                  component: () => import(/* webpackChunkName: 'daily-activity-report' */ '@/views/reports/dailyActivityReport/list')
                },
                {
                  path: 'detail/:blu_id',
                  name: 'DailyActivityReportDetail',
                  meta: {
                    breadcrumb: 'Tug & Barge Daily Activity',
                    parent: { title: 'Daily Trip Activity Report', name: 'DailyTripActivityReport' },
                    title: 'Tug & Barge Daily Activity',
                    permission: { page: 'Reports', name: 'DailyActivityReportDetail', type: 'view' }
                  },
                  component: () => import(/* webpackChunkName: 'daily-activity-report-detail' */ '@/views/reports/dailyActivityReport/detail')
                },
                {
                  path: 'manage-activity',
                  name: 'ManageActivity',
                  meta: {
                    breadcrumb: 'Manage Activity',
                    parent: { title: 'Daily Trip Activity Report', name: 'DailyTripActivityReport' },
                    title: 'Manage Activity',
                    permission: { page: 'Reports', parent: 'Daily Trip Activity Report', name: 'ManageActivity', type: 'view' }
                  },
                  component: () => import(/* webpackChunkName: 'manage-activity' */ '@/views/reports/dailyActivityReport/manageActivity')
                }
              ]
            }
          ]
        },
        {
          path: 'monitoring-report',
          name: 'ReportMonitoringReport',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'List Monitoring Report',
            permission: { page: 'Reports', name: 'ReportMonitoringReport', type: 'view' }
          },
          component: () => import(/* webpackChunkName: 'monitoring-report' */ '@/views/reports/monitoringReport')
        },
        {
          path: 'barge-line-up-report',
          name: 'ReportBargeLineUpReport',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'List Barge Line Up Report',
            permission: { page: 'Reports', name: 'ReportBargeLineUpReport', type: 'view' }
          },
          component: () => import(/* webpackChunkName: 'barge-line-up-report' */ '@/views/reports/bargeLineUpReport')
        },
        {
          path: 'user-logs',
          name: 'ReportUserLogs',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'List User Logs',
            permission: { page: 'Reports', name: 'ReportUserLogs', type: 'view' }
          },
          component: () => import(/* webpackChunkName: 'user-logs' */ '@/views/reports/userLogs')
        },
        {
          path: 'approaching-tugs',
          name: 'ReportApproachingTugs',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'List Approaching Tugboats',
            permission: { page: 'Reports', name: 'ReportApproachingTugs', type: 'view' }
          },
          component: () => import(/* webpackChunkName: 'approaching-tugs' */ '@/views/reports/approachingTugsReport')
        },
        {
          path: 'cost-report',
          name: 'ReportCost',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Daily Activity Report',
            permission: { page: 'Reports', name: 'ReportCost', type: 'view' }
          },
          component: () => import(/* webpackChunkName: 'monitoring-report' */ '@/views/reports/costReport')
        },
        {
          path: 'hold-hatch-cleanliness',
          name: 'ReportHoldHatchCleanliness',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Hold or Hatch Cleanliness',
            permission: { page: 'Reports', name: 'ReportHoldHatchCleanliness', type: 'view' }
          },
          component: () => import(/* webpackChunkName: 'hold-or-hatch-cleanliness' */ '@/views/reports/holdHatchCleanliness/list')
        },
        {
          path: 'quarterly-inspection',
          name: 'ReportQuarterlyInspection',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Quarterly Inspection Report',
            permission: { page: 'Reports', name: 'ReportQuarterlyInspection', type: 'view' }
          },
          component: () => import(/* webpackChunkName: 'quarterly-inspection' */ '@/views/reports/quarterlyInspection')
        },
        {
          path: 'cargo-stolen',
          name: 'ReportCargoStolen',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Cargo Stolen Report',
            permission: { page: 'Reports', name: 'ReportCargoStolen', type: 'view' }
          },
          component: () => import(/* webpackChunkName: 'cargo-stolen' */ '@/views/reports/cargoStolen')
        },
        {
          path: 'cargo-contamination',
          name: 'ReportCargoContamination',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Cargo Contamination Report',
            permission: { page: 'FLFFCReport', name: 'ReportCargoContamination', type: 'view' }
          },
          component: () => import(/* webpackChunkName: 'cargo-contamination' */ '@/views/reports/cargoContamination')
        },
        {
          path: 'checklist-monitoring',
          name: 'ReportDailyChecklistMonitoring',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Daily Checklist Monitoring Report',
            permission: { page: 'FLFFCReport', name: 'ReportDailyChecklistMonitoring', type: 'view' }
          },
          component: () => import(/* webpackChunkName: 'checklist-monitoring' */ '@/views/reports/checklistMonitoring')
        },
        {
          path: 'document-tracking',
          name: 'ReportDocumentTracking',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Document Tracking Report',
            permission: { page: 'Reports', name: 'ReportDocumentTracking', type: 'view' }
          },
          component: () => import(/* webpackChunkName: 'document-tracking' */ '@/views/reports/documentTrackingReport')
        },
        {
          path: 'tug-barge-performance',
          component: () => import(/* webpackChunkName: 'tug-barge-performance' */ '@/views/reports/tugBargePerformance'),
          children: [
            {
              path: '',
              redirect: () => ({ name: 'TugBargePerformanceList' })
            },
            {
              path: '',
              component: () => import(/* webpackChunkName: 'daily-activity-report' */ '@/views/reports/dailyActivityReport'),
              children: [
                {
                  path: 'list',
                  name: 'TugBargePerformanceList',
                  meta: {
                    breadcrumb: null,
                    parent: null,
                    title: 'Tug & Barge Performance',
                    permission: { page: 'Reports', name: 'TugBargePerformanceList', type: 'view' }
                  },
                  component: () => import(/* webpackChunkName: 'tug-barge-performance' */ '@/views/reports/tugBargePerformance/list')
                },
                {
                  path: 'detail/:id',
                  name: 'TugBargePerformanceDetail',
                  meta: {
                    breadcrumb: 'Detail Tug & Barge Performance',
                    parent: { title: 'Tug & Barge Performance', name: 'TugBargePerformanceList' },
                    title: 'Detail Tug & Barge Performance',
                    permission: { page: 'Reports', name: 'TugBargePerformanceDetail', type: 'view' }
                  },
                  component: () => import(/* webpackChunkName: 'tug-barge-performance-detail' */ '@/views/reports/tugBargePerformance/detail')
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: '/master-data',
      component: () => import(/* webpackChunkName: 'master-data-base' */ '@/views/base'),
      children: [
        {
          path: 'owner-management',
          name: 'MasterDataOwnerManagementList',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Owner Management',
            permission: { page: 'Master Data', name: 'MasterDataOwnerManagementList', type: 'view' }
          },
          component: () => import('@/views/masterData/ownerManagement')
        },
        {
          path: 'agency-management',
          name: 'MasterDataAgencyManagementList',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Agency Management',
            permission: { page: 'Settings', name: 'MasterDataAgencyManagementList', type: 'view' }
          },
          component: () => import('@/views/masterData/agencyManagement')
        },
        {
          path: 'barge-management',
          component: () => import(/* webpackChunkName: 'settings-barge-management' */ '@/views/settings/bargeManagement'),
          children: [
            {
              path: '',
              redirect: () => ({ name: 'MasterDataBargeManagementList' })
            },
            {
              path: 'list',
              component: () => import(/* webpackChunkName: 'settings-barge-management' */ '@/views/settings/bargeManagement'),
              children: [
                {
                  path: '',
                  name: 'MasterDataBargeManagementList',
                  meta: {
                    breadcrumb: null,
                    parent: null,
                    title: 'List Barge Management',
                    permission: { page: 'Settings', name: 'MasterDataBargeManagementList', type: 'view' }
                  },
                  component: () => import(/* webpackChunkName: 'settings-barge-management' */ '@/views/settings/bargeManagement/list')
                },
                {
                  path: 'create',
                  name: 'MasterDataBargeManagementCreate',
                  meta: {
                    breadcrumb: 'Add Barge',
                    parent: { title: 'List Barge Management', name: 'MasterDataBargeManagementList' },
                    title: 'Add Barge',
                    permission: { page: 'Settings', name: 'MasterDataBargeManagementList', type: 'add' }
                  },
                  component: () => import(/* webpackChunkName: 'settings-barge-management' */ '@/views/settings/bargeManagement/createDetailEdit')
                },
                {
                  path: 'detail',
                  name: 'MasterDataBargeManagementDetail',
                  meta: {
                    breadcrumb: 'Detail Barge',
                    parent: { title: 'List Barge Management', name: 'MasterDataBargeManagementList' },
                    title: 'Detail Barge',
                    permission: { page: 'Settings', name: 'MasterDataBargeManagementList', type: 'view' }
                  },
                  component: () => import(/* webpackChunkName: 'settings-barge-management' */ '@/views/settings/bargeManagement/createDetailEdit')
                },
                {
                  path: 'edit',
                  name: 'MasterDataBargeManagementEdit',
                  meta: {
                    breadcrumb: 'Edit Barge',
                    parent: { title: 'List Barge Management', name: 'MasterDataBargeManagementList' },
                    title: 'Edit Barge',
                    permission: { page: 'Settings', name: 'MasterDataBargeManagementList', type: 'edit' }
                  },
                  component: () => import(/* webpackChunkName: 'settings-barge-management' */ '@/views/settings/bargeManagement/createDetailEdit')
                }
              ]
            }
          ]
        },
        {
          path: 'tug-management',
          component: () => import(/* webpackChunkName: 'settings-tug-management' */ '@/views/settings/tugManagement'),
          children: [
            {
              path: '',
              redirect: () => ({ name: 'MasterDataTugManagementList' })
            },
            {
              path: 'list',
              component: () => import(/* webpackChunkName: 'settings-tug-management' */ '@/views/settings/tugManagement'),
              children: [
                {
                  path: '',
                  name: 'MasterDataTugManagementList',
                  meta: {
                    breadcrumb: null,
                    parent: null,
                    title: 'Tug Management',
                    permission: { page: 'Settings', name: 'MasterDataTugManagementList', type: 'view' }
                  },
                  component: () => import(/* webpackChunkName: 'settings-tug-management' */ '@/views/settings/tugManagement/list')
                },
                {
                  path: 'create',
                  name: 'MasterDataTugManagementCreate',
                  meta: {
                    breadcrumb: 'Add Tugboat',
                    parent: { title: 'Tug Management', name: 'MasterDataTugManagementList' },
                    title: 'Add Tugboat',
                    permission: { page: 'Settings', name: 'MasterDataTugManagementList', type: 'add' }
                  },
                  component: () => import(/* webpackChunkName: 'settings-tug-management' */ '@/views/settings/tugManagement/createDetailEdit')
                },
                {
                  path: 'detail',
                  name: 'MasterDataTugManagementDetail',
                  meta: {
                    breadcrumb: 'Detail Tugboat',
                    parent: { title: 'List Tug Management', name: 'MasterDataTugManagementList' },
                    title: 'Detail Tugboat',
                    permission: { page: 'Settings', name: 'MasterDataTugManagementList', type: 'view' }
                  },
                  component: () => import(/* webpackChunkName: 'settings-tug-management' */ '@/views/settings/tugManagement/createDetailEdit')
                },
                {
                  path: 'edit',
                  name: 'MasterDataTugManagementEdit',
                  meta: {
                    breadcrumb: 'Edit Tugboat',
                    parent: { title: 'List Tug Management', name: 'MasterDataTugManagementList' },
                    title: 'Edit Tugboat',
                    permission: { page: 'Settings', name: 'MasterDataTugManagementList', type: 'edit' }
                  },
                  component: () => import(/* webpackChunkName: 'settings-tug-management' */ '@/views/settings/tugManagement/createDetailEdit')
                }
              ]
            }
          ]
        },
        {
          path: 'tug-barges',
          name: 'MasterDataTugBargesList',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Summary Tug & Barge Combination',
            permission: { page: 'Settings', name: 'MasterDataTugBargesList', type: 'view' }
          },
          component: () => import(/* webpackChunkName: 'master-data-tug-barges' */  '@/views/masterData/tugAndBargeCombination')
        },
        {
          path: 'key-activity-status',
          component: () => import('@/views/masterData/keyActivityStatus'),
          children: [
            {
              path: 'oee-items-management',
              name: 'MasterDataOEEItemsManagement',
              meta: {
                breadcrumb: null,
                parent: null,
                title: 'OEE Items Management',
                permission: { page: 'Key Activity & Status', name: 'MasterDataOEEItemsManagement', type: 'view' }
              },
              component: () => import('@/views/masterData/keyActivityStatus/OEEItemsManagement')
            },
            {
              path: 'tms-activity-status',
              name: 'MasterDataTMSActivityStatus',
              meta: {
                breadcrumb: null,
                parent: null,
                title: 'TMS Key Activity & Status',
                permission: { page: 'Key Activity & Status', name: 'MasterDataTMSActivityStatus', type: 'view' }
              },
              component: () => import('@/views/masterData/keyActivityStatus/tmsActivityStatus')
            }
          ]
        },
        {
          path: 'spot-cost',
          name: 'SpotCostList',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Freight Cost',
            permission: { page: 'Settings', name: 'SpotCostList', type: 'view' }
          },
          component: () => import('@/views/masterData/spotCost')
        },
        {
          path: 'bridge-schedule',
          name: 'BridgeScheduleList',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Bridge Schedule',
            permission: { page: 'Settings', name: 'BridgeScheduleList', type: 'view' }
          },
          component: () => import('@/views/masterData/bridgeSchedule')
        },
        {
          path: 'vessel-management',
          name: 'MasterDataVesselManagementList',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Vessel Management',
            permission: { page: 'Settings', name: 'MasterDataVesselManagementList', type: 'view' }
          },
          component: () => import('@/views/masterData/vesselManagement')
        },
        {
          path: 'location-management',
          name: 'LocationManagementList',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Location Management',
            permission: { page: 'Settings', name: 'LocationManagementList', type: 'view' }
          },
          component: () => import('@/views/masterData/locationManagement')
        },
        {
          path: 'exchange-rate',
          name: 'ExchangeRateList',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Exchange Rate',
            permission: { page: 'Settings', name: 'ExchangeRateList', type: 'view' }
          },
          component: () => import('@/views/masterData/exchangeRate')
        },
        {
          path: 'site-management',
          name: 'SiteManagementList',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Site Management',
            permission: { page: 'Settings', name: 'SiteManagementList', type: 'view' }
          },
          component: () => import('@/views/masterData/siteManagement')
        }
      ]
    },
    {
      path: '/settings',
      component: () => import(/* webpackChunkName: 'settings-base' */ '@/views/base'),
      children: [
        {
          path: 'user-management',
          component: () => import(/* webpackChunkName: 'settings-user-management' */ '@/views/settings/authorization/userManagement'),
          children: [
            {
              path: '',
              name: 'AuthorizationUserManagement',
              meta: {
                breadcrumb: null,
                parent: null,
                title: 'List User Management',
                permission: { page: 'Settings', name: 'AuthorizationUserManagement', type: 'view' }
              },
              component: () => import(/* webpackChunkName: 'settings-user-management-list' */ '@/views/settings/authorization/userManagement/list')
            },
            {
              path: 'create',
              name: 'AuthorizationUserManagementCreate',
              meta: {
                breadcrumb: 'Add User',
                parent: { title: 'List User Management', name: 'AuthorizationUserManagement' },
                title: 'Add User',
                permission: { page: 'Settings', name: 'AuthorizationUserManagement', type: 'add' }
              },
              component: () => import(/* webpackChunkName: 'settings-user-management-create' */ '@/views/settings/authorization/userManagement/createEditDetail')
            },
            {
              path: 'detail',
              name: 'AuthorizationUserManagementDetail',
              meta: {
                breadcrumb: 'Detail User',
                parent: { title: 'List User Management', name: 'AuthorizationUserManagement' },
                title: 'Detail User',
                permission: { page: 'Settings', name: 'AuthorizationUserManagement', type: 'view' }
              },
              component: () => import(/* webpackChunkName: 'settings-user-management-detail' */ '@/views/settings/authorization/userManagement/createEditDetail')
            },
            {
              path: 'edit',
              name: 'AuthorizationUserManagementEdit',
              meta: {
                breadcrumb: 'Edit User',
                parent: { title: 'List User Management', name: 'AuthorizationUserManagement' },
                title: 'Edit User',
                permission: { page: 'Settings', name: 'AuthorizationUserManagement', type: 'edit' }
              },
              component: () => import(/* webpackChunkName: 'settings-user-management-edit' */ '@/views/settings/authorization/userManagement/createEditDetail')
            },
            {
              path: 'group-management',
              name: 'AuthorizationGroupManagement',
              meta: {
                breadcrumb: null,
                parent: null,
                title: 'List Group Management',
                permission: { page: 'Settings', name: 'AuthorizationGroupManagement', type: 'view' }
              },
              component: () => import(/* webpackChunkName: 'settings-group-management' */ '@/views/settings/authorization/groupManagement')
            },
            {
              path: 'permission',
              name: 'AuthorizationPermission',
              meta: {
                breadcrumb: null,
                parent: null,
                title: 'List Permission',
                permission: { page: 'Settings', name: 'AuthorizationPermission', type: 'view' }
              },
              component: () => import(/* webpackChunkName: 'settings-permission' */ '@/views/settings/authorization/permission')
            }
          ]
        },
        {
          path: 'menu-management',
          component: () => import(/* webpackChunkName: 'settings-permission' */ '@/views/settings/menuManagement'),
          children: [
            {
              path: 'list',
              name: 'MenuManagement',
              meta: {
                breadcrumb: null,
                parent: null,
                title: 'Menu Management',
                permission: { page: 'Settings', name: 'MenuManagement', type: 'view' }
              },
              component: () => import(/* webpackChunkName: 'settings-permission' */ '@/views/settings/menuManagement')
            }
          ]
        }
      ]
    },
    {
      path: '/not-found',
      name: 'NotFound',
      component: () => import(/* webpackChunkName: 'settings-base' */ '@/views/base'),
      children: [
        {
          path: '',
          name: 'NotFound',
          meta: {
            breadcrumb: null,
            parent: null,
            title: 'Not Found',
            permission: { page: 'NotFound', name: 'NotFound', type: 'view' }
          },
          component: () => import(/* webpackChunkName: '404' */ '@/views/404')
        }
      ]

    },
    {
      path: '*',
      redirect: () => ({ name: 'NotFound' })
    }
  ]
})

const untrackedRoutes = ['/', '/login']

router.beforeEach((to, from, next) => {
  if (to.path !== '/login' && !store.getters['Auth/isAuthenticated']) {
    next({ name: 'Login', replace: true, query: { redirect: to.fullPath} })
  } else {
    const me = store.getters['Auth/me']
    if(!me) return next()
    const menu = me.hasOwnProperty('permissions') ? me.permissions : []
    store.dispatch('UploadFile/reset')
    const permissionNeeded = menu.find(menu => menu.url_name && menu.url_name === to?.name)
    if (to?.path?.includes('home') || !permissionNeeded) {
      return next()
    }

    const { permission: { name } } = to?.meta || {}
    const menuPage = menu.find(menu => (menu.url_name && menu.url_name.toLowerCase() === name.toLowerCase()) || menu.name.toLowerCase() === name.toLowerCase())
    const hasChildren = menuPage?.children?.filter(c => !c.is_permission_only).length > 0;

    const userPermissions = (store.getters['Auth/me'])?.permissions || []
    const userPagePermission = userPermissions.find(p => (p.url_name && p.url_name.toLowerCase() === name.toLowerCase()) || p.name.toLowerCase() === name.toLowerCase())
    let hasPermission = false
    if (hasChildren) {
      const childPermission  = userPagePermission?.children?.find(access => (access.url_name && access.url_name.toLowerCase() === name.toLowerCase()) || access.name.toLowerCase() === name.toLowerCase())
      hasPermission = childPermission?.permissions?.length > 0
    } else {
      hasPermission = userPagePermission?.permissions?.length > 0
    }
    if (hasPermission) {
      next()
    } else {
      next({ path: '/not-found', replace: true })
    }
  }
})

router.afterEach(to => {
  if (!untrackedRoutes.includes(to.path) && store.getters['Auth/me']) {
    store.dispatch('UserLog/postUserLogs', {
      username: store.getters['Auth/me'].username,
      pagename: to.path
    })
  }
})

export default router
